<div class="general-account-container">
    <div class="general-account-container-title">{{ 'myAccount.general.generalInfo' | translate }}</div>
    <!-- Content for General Information goes here -->
    <!-- Responsive layout: 3 columns on desktop, 1 column on mobile -->
    @if(accountData != null && accountData.isValid == false) {
    <jjames-alert type="warning"
        [title]="'myAccount.general.invalidAccount' | translate"></jjames-alert>
    }
    <jjames-card>
        <form [formGroup]="editForm" (ngSubmit)="editAccount()" class="space-y-8">
            <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-6">
                <div class="lg:col-span-1">
                    <!-- Photo Section -->
                    <div class="photo-section">
                        <label class="block text-sm font-medium text-gray-700 mb-2">{{ 'myAccount.general.profilePhoto' | translate }}</label>
                        <!-- Hidden file input -->
                        <input type="file" #photoInput class="hidden" accept="image/jpeg,image/png,image/gif,image/webp"
                            (change)="onPhotoSelected($event)" />
                        <div class="mt-1 flex flex-col items-center lg:items-start">
                            <div class="relative cursor-pointer group" (click)="onPhotoClick()">
                                @if (getProfilePhoto()) {
                                <img [src]="getProfilePhoto()" alt="Profile photo"
                                    class="h-24 w-24 rounded-full object-cover border-2 border-gray-200" />
                                } @else {
                                <span
                                    class="inline-block h-24 w-24 rounded-full overflow-hidden bg-gray-100 border-2 border-gray-200">
                                    <svg class="h-full w-full text-gray-300" fill="currentColor" viewBox="0 0 24 24">
                                        <path d="M24 24H0V0h24v24z" fill="none" />
                                        <path
                                            d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
                                    </svg>
                                </span>
                                }
                                <!-- Upload overlay -->
                                <div
                                    class="absolute inset-0 flex items-center justify-center rounded-full bg-black/0 group-hover:bg-black/40 transition-all duration-200">
                                    @if (isUploadingPhoto()) {
                                    <mat-spinner diameter="24" class="text-white"></mat-spinner>
                                    } @else {
                                    <div
                                        class="opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-white">
                                        <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
                                        </svg>
                                    </div>
                                    }
                                </div>
                            </div>
                            <span class="mt-2 text-xs text-gray-500">{{ 'myAccount.general.changePhoto' | translate }}</span>
                        </div>
                    </div>
                </div>
                <div class="lg:col-span-2">
                    <!-- Personal Information Section -->
                    <div class="personal-info-section space-y-4">
                        <div>
                            <jjames-input inputId="firstName" [label]="'myAccount.general.firstName' | translate" type="text" formControlName="firstName"
                                [required]="true" [variant]="isFieldInvalid('firstName') ? 'error' : 'default'"
                                [errorMessage]="getFieldError('firstName')" [placeholder]="'myAccount.general.firstNamePlaceholder' | translate">
                            </jjames-input>
                        </div>
                        <div>
                            <jjames-input inputId="lastName" [label]="'myAccount.general.lastName' | translate" type="text" formControlName="lastName"
                                [required]="true" [variant]="isFieldInvalid('lastName') ? 'error' : 'default'"
                                [errorMessage]="getFieldError('lastName')" [placeholder]="'myAccount.general.lastNamePlaceholder' | translate">
                            </jjames-input>
                        </div>
                        <div>
                            <jjames-input type="email" inputId="email" [label]="'myAccount.general.email' | translate" formControlName="email"
                                [required]="true" [variant]="isFieldInvalid('email') ? 'error' : 'default'"
                                [errorMessage]="getFieldError('email')"></jjames-input>
                        </div>
                    </div>
                </div>
                <div class="lg:col-span-3">
                    <!-- Account Edit Button Section -->
                    <div class="account-edit-section flex justify-center lg:justify-start">
                        <jjames-button class="mt-4" variant="primary" (click)="editAccount()">{{ 'myAccount.general.editAccount' | translate }}</jjames-button>
                    </div>
                </div>
            </div>
        </form>
    </jjames-card>
</div>